import React from 'react';
import PropTypes from 'prop-types';

const SignedBarChartLabel = ({ x, y, value, textAnchor }) => (
  <text x={x} y={y + 3} fontSize={11} textAnchor={textAnchor}>
    {`${Math.abs(value[1])}%`}
  </text>
);

SignedBarChartLabel.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  value: PropTypes.arrayOf(PropTypes.number),
  textAnchor: PropTypes.string,
};

export default SignedBarChartLabel;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/SignedBarChart/SignedBarChartLabel.js